import { Button } from '@seen/ui'
import type { JSX } from 'react'
import { usePortalStore } from '#src/hooks/usePortalStore.ts'

export function FeedbackButton(): JSX.Element {
  const setFeedbackDialogOpen = usePortalStore(
    (state) => state.setFeedbackDialogOpen
  )

  return (
    <Button
      variant="outline"
      className="w-full"
      onClick={() => setFeedbackDialogOpen(true)}
    >
      Feedback
    </Button>
  )
}
